import { render, staticRenderFns } from "./expand-sequence-badge.vue?vue&type=template&id=3f3139c2"
import script from "./expand-sequence-badge.vue?vue&type=script&lang=js"
export * from "./expand-sequence-badge.vue?vue&type=script&lang=js"
import style0 from "./expand-sequence-badge.vue?vue&type=style&index=0&id=3f3139c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports